module.exports = __webpack_public_path__ + "img/splash.adb43eea.jpg";